import React from "react";
import { Link } from "react-router-dom";
import { useTheme, currentBrandSlug } from "@/contexts/ThemeProvider";
import BrandLabel from "@/components/brand/BrandLabel";
import { cn } from "@/lib/utils";

const BrandFooter = () => {
  const { theme } = useTheme();
  const slug = currentBrandSlug(theme);
  const isBrionj = slug === "brionj";
  const isCastlewood = slug === "castlewood";
  return (
    <footer
      className={cn(
        "mt-24 border-t",
        isBrionj && "border-[hsl(var(--brand-accent))]/30",
        !isBrionj && "border-border"
      )}
      data-testid="brand-footer"
    >
      <div className="container-rail py-12 md:py-16 grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr] text-[13px]">
        <div>
          <BrandLabel>The Group</BrandLabel>
          <p className="mt-4 max-w-[36ch] text-muted-foreground leading-relaxed font-body">
            Grand Metropolitan Hotels is a family of hospitality houses, each with its own register of welcome.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/castlewood" className="underline underline-offset-4 hover:text-foreground" data-testid="footer-castlewood">Castlewood</Link>
            <span>•</span>
            <Link to="/vela" className="underline underline-offset-4 hover:text-foreground" data-testid="footer-vela">Vela</Link>
            <span>•</span>
            <Link to="/brionj" className="underline underline-offset-4 hover:text-foreground" data-testid="footer-brionj">Brionj</Link>
          </div>
        </div>
        <div>
          <BrandLabel>Discover</BrandLabel>
          <ul className="mt-4 space-y-3 text-muted-foreground">
            <li><Link to="/search" className="hover:text-foreground">Find a stay</Link></li>
            <li><Link to="/castlewood/search" className="hover:text-foreground">Castlewood hotels</Link></li>
            <li><Link to="/vela/search" className="hover:text-foreground">Vela coastal retreats</Link></li>
            <li><Link to="/brionj/collection" className="hover:text-foreground">Brionj residences</Link></li>
          </ul>
        </div>
        <div>
          <BrandLabel>Your account</BrandLabel>
          <ul className="mt-4 space-y-3 text-muted-foreground">
            <li><Link to="/bookings" className="hover:text-foreground">Your stays</Link></li>
            <li><Link to="/favourites" className="hover:text-foreground">Favourites</Link></li>
            <li><Link to="/auth/sign-in" className="hover:text-foreground">Sign in</Link></li>
            <li><Link to="/admin" className="hover:text-foreground">Operator login</Link></li>
          </ul>
        </div>
        <div>
          <BrandLabel>The house</BrandLabel>
          <ul className="mt-4 space-y-3 text-muted-foreground">
            <li>Press</li>
            <li>Careers</li>
            <li>Sustainability</li>
            <li>Privacy &amp; cookies</li>
          </ul>
        </div>
      </div>
      <div className="container-rail border-t border-border py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[12px] text-muted-foreground">
        <div>
          © {new Date().getFullYear()} Grand Metropolitan Hotels. Prototype.
        </div>
        {isCastlewood && <div className="font-display italic">— Hospitality, kept by hand.</div>}
        {isBrionj && <div className="font-display italic text-[hsl(var(--brand-accent))]">— By enquiry only.</div>}
      </div>
    </footer>
  );
};

export default BrandFooter;
